const defaultProps = {
  icon: "",
  iconAlt: "",
  name: "click me",
  onClick: ()=> {}
};

export default function SideNavButton(props = defaultProps) {
  return (
    <div className="side-nav-button">
      <button onClick={props.onClick}>
        <img src={props.icon} alt={props.iconAlt} />
        <span className="hide-on-collapse">{props.name}</span>
      </button>
    </div>
  );
}
